import React, { useContext } from "react";
import UserContext from "../../contexts/user";

export const AuthorizedFor = ({ children, roles = [] }) => {
  const { userRole } = useContext(UserContext);

  return roles.map((role) => {
    if (role === userRole) {
      return <>{children}</>;
    }
  });
  return <></>;
};
